<template>
    <template v-if="item !== null && allowedComponentNames.indexOf(item.systemName) != -1">
        <component :is="item.systemName" :id="(`module${item.id}`)" :item="item"></component>
    </template>
</template>
<script>
import Accordions from '../modules/accordions.vue';
import BrandingText from '../modules/branding-text.vue';
import Breaker from '../modules/breaker.vue';
import FullScreenImage from '../modules/full-screen-image.vue';
import FullScreenVideo from '../modules/full-screen-video.vue';
import IconBulletList from '../modules/icon-bullet-list.vue';
import ImageGrid from '../modules/image-grid.vue';
import Logos from '../modules/logos.vue';
import Specifications from '../modules/specifications.vue';
import Tabs from '../modules/tabs.vue';
import Testimonials from '../modules/testimonials.vue';
import TextImage from '../modules/text-image.vue';
import Text from '../modules/text.vue';

export default {
    name: 'ParagraphItem',
    components: {
        Accordions,
        BrandingText,
        Breaker,
        FullScreenImage,
        FullScreenVideo,
        IconBulletList,
        ImageGrid,
        Logos,
        Specifications,
        Tabs,
        Testimonials,
        TextImage,
        Text,
    },
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            allowedComponentNames: [
                'Accordions',
                'BrandingText',
                'Breaker',
                'FullScreenImage',
                'FullScreenVideo',
                'IconBulletList',
                'ImageGrid',
                'Logos',
                'Specifications',
                'Tabs',
                'Testimonials',
                'TextImage',
                'Text',
            ]
        };
    }
};
</script>
